import React from 'react'
import { ServiceProvider } from '../../types'
import { serviceProviderService } from '../../services'
import withEntityRequest from '../withEntityRequest'
import ParentOrganization from '../ParentOrganization'

interface ParentCardProps {
	entity: ServiceProvider
}

function ServiceProviderCard({ entity }: ParentCardProps) {
	return <ParentOrganization link={`/serviceprovider/${entity.id}/children`} name={entity.name} />
}

export default withEntityRequest(ServiceProviderCard, { type: 'Service Provider', getById: id => serviceProviderService.getById(id) })
